import { useEffect } from "react";
import { useParams } from "react-router-dom";

// components
// import ListingMain from "components/Listing";

// context
import { ListingData } from "context/ListingData";
import { ListingNew } from "components/ListingNew";
import { elasticLog } from "helpers/elastic";

const ListingPage = () => {
	const { id } = useParams();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const newListingArray = window.location.pathname
		.split("/")
		[window.location.pathname.split("/").length - 1].split("-");
	const newListingId = newListingArray[newListingArray.length - 1];

	// useEffect(() => {
	// 	if (["OCC6yYcLiB5eA1LB", "CE020iHh4xYCmbgl"].includes(newListingId || id)) {
	// 		window.location.href =
	// 			"https://www.saffronstays.com/view/mariposa-by-the-river-a-set-of-threebedroom-villas-in-karjat-with-a-pool-and-garden-ideal-for-small-families-to-bond-peacefully-in-nature-C6SwcnQMNXwEj91M?adults=8&children=&infants=&rooms=4&checkin=&checkout=";
	// 	}
	// }, []);

	useEffect(() => {
		const search = new URLSearchParams(window.location.search);
		const obj = {
			adults: search.get("adults"),
			infants: search.get("infants"),
			rooms: search.get("rooms"),
			seoUrl: id,
			id: newListingId || id,
			checkin: search.get("checkin"),
			checkout: search.get("checkout"),
		};
		elasticLog({
			index: "listing-view",
			payload: obj,
		});
	}, []);

	return (
		<ListingData id={id}>
			<ListingNew id={id} />
		</ListingData>
	);
};

export default ListingPage;
